import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { SCREEN_SETTINGS } from '../../../themes/theme';

import form from '../../../commonStyles/formStyles.module.css';
import common from '../../formElements/formElementStyles/commonFormElements.module.css';

/**
 * No / Yes Radio button picker
 *
 * Default is radioButtonPick
 * @param id selector id
 * @param label selector label
 * @param mandatory whether is required field
 * @param onChange  Callback function to tell parent of change. This is returned as
 * a boolean.  true = 'Yes' false = 'No'
 * @param text
 * @param disabled Default = false
 * @param radioButtonPick boolean Sets initial radio selection.
 *     false (default) means 'No' is selected.
 *     true = 'Yes' selected
 * @param isAuditable shows audit timer
 * @param onSearchAuditItems action on audit timer click
 *
 */

const NoYesRadioPicker = ({
    id,
    onChange,
    text,
    label,
    mandatory = false,
    disabled = false,
    radioButtonPick = false,
    isAuditable = false,
    onSearchAuditItems,
}) => {
    const [radioSelection, setRadioSelection] = useState(radioButtonPick);

    const handleRadioClick = (e) => {
        if (!disabled && e.target.value !== undefined) {
            const value = e.target.value === 'true';
            setRadioSelection(value);
            onChange(value);
        }
    };

    // Set radio selection from options on first entry
    useEffect(() => {
        setRadioSelection(radioButtonPick);
    }, [radioButtonPick]);

    return (
        <div className={form.yesNoRadioButtons}>
            <Typography variant="h6" data-testid={'label_text'}>
                {text || ''}{' '}
            </Typography>
            <label id={id} htmlFor={id} className={common.formLabel}>
                <span>{label} {mandatory && <sup>*</sup>}</span>
                {isAuditable && (
                    <div>
                        <RestoreIcon onClick={() => onSearchAuditItems(label)} />
                    </div>
                )}
            </label>

            <RadioGroup
                row
                aria-labelledby={id}
                name="no-yes-radio-buttons-group"
                value={radioSelection}
                onClick={handleRadioClick}>
                <FormControlLabel
                    data-testid={'radio_button_no'}
                    value={false}
                    control={<Radio disabled={disabled} />}
                    label="No"
                />
                <FormControlLabel
                    data-testid={'radio_button_yes'}
                    value={true}
                    control={<Radio disabled={disabled} />}
                    label="Yes"
                />
            </RadioGroup>
            <Box sx={{ height: SCREEN_SETTINGS.gap.large }} />
        </div>
    );
};

NoYesRadioPicker.propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    mandatory: PropTypes.bool,
    text: PropTypes.string,
    onChange: PropTypes.func,
    radioButtonPick: PropTypes.bool,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func
};

export default NoYesRadioPicker;
